import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPagePremium from './pages/LandingPagePremium';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ClienteLogin from './pages/ClienteLogin';
import ClienteDashboard from './pages/ClienteDashboard';
import { Toaster } from 'sonner';

// Protected Route Component
const ProtectedRoute = ({ children, requiredType }) => {
  const token = localStorage.getItem('token');
  const userType = localStorage.getItem('userType');
  
  if (!token || (requiredType && userType !== requiredType)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPagePremium />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/cliente/login" element={<ClienteLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute requiredType="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cliente/dashboard" 
            element={
              <ProtectedRoute requiredType="cliente">
                <ClienteDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
